export default ['/login_check', '/job'];
